import React from 'react';
import { withTheme, op } from '@elliemae/ds-system';
import { stripUnit, rem } from 'polished';

var Circle = function Circle(_ref) {
  var checked = _ref.checked,
      theme = _ref.theme;
  var r = stripUnit(op('-', theme.breakpoints.medium, rem(window.innerWidth, 13))) >= 0 ? 6 : 4;
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("circle", {
    className: checked ? 'checked' : 'unchecked',
    r: r,
    cx: "50%",
    cy: "50%"
  }));
};

var Circle$1 = withTheme(Circle);

export default Circle$1;
//# sourceMappingURL=Circle.js.map
